
import { defuFn } from '/Users/duncandeklerk/Dev/ProjectsVue/airabica/airabica-nuxtapp/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
